import { merge } from 'lodash'
import contentSettings from '~/sites/soh/content.settings'

const overloadSettings = {}

export default merge(contentSettings, overloadSettings)
